import { useStatusOptions } from "./useStatusOptions";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";

export default function StatusSelect({ value, onChange }) {
  const { options, loading } = useStatusOptions();

  return (
    <FormControl fullWidth>
      <InputLabel id="status-label">Status</InputLabel>

      <Select
        labelId="status-label"
        value={Number(value)}
        label="Status"
        disabled={loading}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
